import React, { useState } from "react";
import MessageList from "./MessageList";
import MessageContent from "./MessageContent";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";

const MessagesSection = () => {
  // const [search, setSearch] = useState("");
  const [activeChat, setActiveChat] = useState(null);
  const [searchParams] = useSearchParams();
  const chatIdFromUrl = searchParams.get("chatId");
  const [showChat, setShowChat] = useState(false);
  const isMobile = window.innerWidth < 768;
  // console.log(chatIdFromUrl, "hbh");
  // const contacts = [
  //   { name: "Nitesh Chowdhary", message: "Nitesh sent an attachment", date: "Feb 24", avatar: "https://via.placeholder.com/40" },
  //   { name: "Dilsha Mujeeb", message: "Hello i'm interested in working at your company....", date: "May 20, 2024", avatar: "https://via.placeholder.com/40" },
  //   { name: "Aniket Paul", message: "Hello", date: "Sep 29, 2023", avatar: "https://via.placeholder.com/40" },
  // ];

  // const suggestedContacts = [
  //   { name: "Subhajit Saha", title: "Sr. Frontend HTML Developer at Symlink Technologies LLP", avatar: "https://via.placeholder.com/40" },
  //   { name: "Buddhadev Haldar", title: "mern stack | web developer", avatar: "https://via.placeholder.com/40" },
  //   { name: "PROKASH MALO", title: "Full Stack Developer (MERN) with QA Expertise", avatar: "https://via.placeholder.com/40" },
  //   { name: "Animesh Manna", title: "Founder of jsonviewer.tools | Building StructViz", avatar: "https://via.placeholder.com/40" },
  //   { name: "Sujay Mondal", title: "Project Manager & Technical Head", avatar: "https://via.placeholder.com/40" },
  //   { name: "MD Sakil Ahmed", title: "Frontend web developer | ReactJs", avatar: "https://via.placeholder.com/40" },
  //   { name: "Ravish Kumar", title: "Software Developer", avatar: "https://via.placeholder.com/40" },
  // ];

  return (
    <section className="flex flex-col md:flex-row h-full">
      <div
        className={`
      w-full md:w-[30%] border-r border-gray-200
      ${showChat ? "hidden md:block" : "block"}
    `}
      >
        <MessageList
          onSelectChat={(chat) => {
            setActiveChat(chat);
            setShowChat(true);
          }}
          //  defaultChatId={isMobile ? null : chatIdFromUrl}
          defaultChatId={chatIdFromUrl}
        />
      </div>

      <div
        className={`
      w-full md:w-[70%]
      ${!showChat ? "hidden md:block" : "block"}
    `}
      >
        <MessageContent
          activeChat={activeChat}
          onBack={() => setShowChat(false)}
        />
      </div>
    </section>
  );
};

export default MessagesSection;
